import React from "react";
import styled from "styled-components";
import { media } from "styled-bootstrap-grid";
import {Helmet} from "react-helmet";

import Button from "../components/button";
import { Headline1, Paragraph } from "../components/typography";

const CenterWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Content = styled.div`
  margin: 0 2rem;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
	margin-bottom: 1rem;
`;
const Stop = styled.div`
	width: 26px;
	height: 26px;
	transform: translateY(-32%);
	margin-right: 0.75rem;
	${media.md`
		width: 30px;
		height: 30px;
  `}
	img {
		width: 100%;
	}
`
const Number = styled.div`
	display: flex;
	align-items: flex-end;
	span:first-child {
		font-size: 80px;
		transform: translateY(20%);
		${media.md`
			font-size: 100px;
  	`}
	}
	span:nth-child(2) {
		font-size: 60px;
		transform: translateY(19%);
		${media.md`
			font-size: 80px;
  	`}
	}
	span:nth-child(3) {
		font-size: 40px;
		transform: translateY(19%);
		${media.md`
			font-size: 60px;
  	`}
	}
`
const Headline = styled(Headline1)`
  font-size: 28px;
  margin-bottom: 1rem;
	${media.md`
		font-size: 36px;
  `}
`;
const StyledParagraph = styled(Paragraph)`
  margin-bottom: 1rem;
`;

const NotFound = () => {
  return (
    <CenterWrapper>
			<Helmet>
				<title>404 | BWS Jahresbericht 2020</title>
			</Helmet>
      <Content>
        <Wrapper>
          <Stop>
            <img src="../assets/stop.svg" />
          </Stop>
          <Number>
						<span>4</span>
						<span>0</span>
						<span>4</span>
					</Number>
        </Wrapper>
        <Headline>Diese Seite existiert nicht</Headline>
        <StyledParagraph>
          Wir konnten die eingegebene Adresse nicht finden. <br />
          Zurück zur Startseite:
        </StyledParagraph>
        <Button
          to="/"
          text="Startseite"
          backgroundcolor="black"
          color="white"
        />
      </Content>
    </CenterWrapper>
  );
};

export default NotFound;
